// Import React and Hooks
import React from 'react'
// Import Redux and Hooks
import { useAppSelector } from './../../hooks/useRedux'



// Loader props
interface loaderProps {
  additionalClass?:string
}

const Loader = ( { additionalClass }:loaderProps ) => {



  // Use selector
  const isLoad = useAppSelector( state => state.general.isLoad )



  return (
    <>
      { isLoad && (
        <div className={`loader ${ additionalClass ? additionalClass : ''}`}>
          <div className="loader__container">
            <svg className="loader__content" viewBox="25 25 50 50">
              <circle className="loader__circular" cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10"/>
            </svg>
          </div>
        </div>
      ) }
    </>
  )
}



export default Loader
